(function ($) {
	if (typeof(wp) === 'object') {
		
		var loadingJSON = false;

		var zelloChannels = {
			init: function()
			{
				this.loadChannels();
				this.searchForm();
			},
			templateLoader: function(sourceURL, excludedSelector)
			{
				var channelCode = __jsVars.channel_code;

				var templateClass = $('.tmpl_wp').not(excludedSelector);

				templateClass.each(function() {

					var thisTemplate = $(this);
					var templateID = thisTemplate.attr('id');
					var templateTarget = $( '.js--' + templateID );
					var templateName = templateID.substr(5);
					var template = wp.template( templateName );

					$.getJSON( sourceURL, function(data) {
						templateTarget.html(template(data));
						zelloChannels.extractLetterForPlaceholderImage();
						if( channelCode==='' || channelCode===undefined ){
							zelloChannels.paginationLoader();
						}
						//zelloChannels.lineClampin();
						loadingJSON = false;
					});
				});
			},
			paginationLoader: function()
			{
				var hash = decodeURIComponent(location.hash.substr(1));
				var pathname = hash.split( '/' );
				var hashBase = pathname[0];
				var urlEnd = '';
				if (!pathname[0]) {
					hashBase = 'popular';
				}
				if (pathname[2]) {
					urlEnd = pathname[2] + '/';
				}
				$('.s-channels-pagination a[data-page]').each(function() {
					var urlBase = $(this).attr('data-href');
					var pageNumber = $(this).attr('data-page');
					$(this).attr('href', urlBase + hashBase + '/' + pageNumber + '/' + urlEnd);
				});
			},
			loadChannels: function()
			{
				var channelCode = __jsVars.channel_code;
				if( channelCode!='' && channelCode!=undefined ){
					loadingJSON = true;
                    var APIurl = 'https://zello.com/channels/';
                    var sourceURL = APIurl;
					sourceURL = APIurl+'api/'+channelCode;
					//sourceURL = '/json/'+channelCode+'.json';
                    zelloChannels.templateLoader(sourceURL);
					$('.channels-single').show();
					$('.channels-list').hide();
				}else{
					$(window).bind( 'hashchange', function() {
						if ( !loadingJSON ) {
							loadingJSON = true;
							var APIurl = 'https://zello.com/channels/';
							var sourceURL = APIurl;
							var hash = decodeURIComponent(location.hash.substr(1));
							var baseURL;
							baseURL = APIurl;
							var lastChar = baseURL.substr(-1);
							if (lastChar == '/') {
								baseURL = baseURL.slice(0, -1);
							}
							var pathname = hash.split( '/' );
							var query = '';
							var searchVal = '';
							var pageNumber = pathname[1];

							if (!pathname[1]) {
								pageNumber = 1;
							}
							if (pathname[2]) {
								query = 'query=' + pathname[2] + '&';
								searchVal = pathname[2];
							}

							sourceURL = baseURL + '/api?page=' + pageNumber + '&' + query + 'max=4';
							zelloChannels.templateLoader(sourceURL);

							if (searchVal) {
								$('.s-channels-search form [type="search"]').attr( 'value', searchVal );
							}

							$("html, body").animate({ scrollTop: 0 }, "slow");
							$('.channels-list').show();
							$('.channels-single').hide();
						}
					});
					$(window).trigger( 'hashchange' );
				}
			},
			searchForm: function()
			{
				$(document.body).on('submit', '.s-channels-search form', function(e) {

					e.preventDefault();

					var searchVal = $(this).find('[type="search"]').val();

					var searchPageURL = window.location.pathname + '#search/1/' + searchVal;

					if (!searchVal) {
						searchPageURL = window.location.pathname;
//					} else if (searchVal.length < 3) {
//						return false;
					}
					window.history.pushState({}, '', searchPageURL);
					$(window).trigger( 'hashchange' );
				});
			},
			extractLetterForPlaceholderImage: function()
			{
				var element = $( 'svg.single-channel__item--image text' );
				element.each(function() {
					var singleElement = $(this)
					var singleElementName = singleElement.attr('data-name');
					singleElement.text(singleElementName.substr(0,1).toUpperCase());
				});
			},
			lineClampin: function()
			{
				var p = $( '.single-channel__description p' );
				var divh = $( '.single-channel__description' ).height();
				while ( $( p ).outerHeight()>divh ) {
					$( p ).text( function (index, text) {
						var orgText = text;
						return orgText.replace(/\W*\s(\S)*$/, '...');
					});
				}
			}
		};
		$(document).ready(function() {
			zelloChannels.init();
		});
		$(window).on('resize', function ()
		{
//			zelloChannels.lineClampin();
		});
		$('body').on('click', '.js--show-share-popup', function(e){
			e.preventDefault();
			$('.channel-share-popup').show();
		});
		$('body').on('click', '.js--close-share-popup', function(e){
			$('.channel-share-popup').hide();
		});
		$('body').on('click', '.js--copy-txt', function(){
			var toCopyTxt = $(this).html();
			console.log('CT'+toCopyTxt);
			var $temp = $("<input>");
			$("body").append($temp);
			$temp.val(toCopyTxt).select();
			document.execCommand("copy");
			$temp.remove();
		});	  
		$('body').on('click', '.js--print-window', function(){
			window.print();
		});	  
	}
})(jQuery);